var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 8 8",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 0.8C1.15817 0.8 0.8 1.15817 0.8 1.6V4.8C0.8 5.24184 1.15817 5.6 1.6 5.6H4.8C5.24184 5.6 5.6 5.24184 5.6 4.8V1.6C5.6 1.15817 5.24184 0.8 4.8 0.8H1.6ZM0 1.6C0 0.716346 0.716346 0 1.6 0H4.8C5.68368 0 6.4 0.71635 6.4 1.6V4.8C6.4 5.68367 5.68367 6.4 4.8 6.4H1.6C0.71635 6.4 0 5.68368 0 4.8V1.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6001 1.6001C7.82101 1.6001 8.0001 1.77918 8.0001 2.0001V6.4001C8.0001 7.28377 7.28377 8.0001 6.4001 8.0001H2.0001C1.77918 8.0001 1.6001 7.82101 1.6001 7.6001C1.6001 7.37918 1.77918 7.2001 2.0001 7.2001H6.4001C6.84194 7.2001 7.2001 6.84194 7.2001 6.4001V2.0001C7.2001 1.77918 7.37918 1.6001 7.6001 1.6001Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2001 1.6001C3.42101 1.6001 3.6001 1.77918 3.6001 2.0001V2.8001H4.4001C4.62101 2.8001 4.8001 2.97918 4.8001 3.2001C4.8001 3.42101 4.62101 3.6001 4.4001 3.6001H3.6001V4.4001C3.6001 4.62101 3.42101 4.8001 3.2001 4.8001C2.97918 4.8001 2.8001 4.62101 2.8001 4.4001V3.6001H2.0001C1.77918 3.6001 1.6001 3.42101 1.6001 3.2001C1.6001 2.97918 1.77918 2.8001 2.0001 2.8001H2.8001V2.0001C2.8001 1.77918 2.97918 1.6001 3.2001 1.6001Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1084ed8eb465cce4bf502ac2358780ed.svg";
export { ForwardRef as ReactComponent };